import type { TQuestionAnswer } from '$/types/components/questions';
import type { GetStaticProps } from 'next';

import ApiClient from '$/ApiClient';
import Layout from '$/components/elements/Layout';
import Providers from '$/components/elements/Layout/Providers';
import { degreeList } from '$/components/elements/Questions/lists/degreeList';
import specializationList from '$/components/elements/Questions/lists/specializationList';
import QuestionsPage from '$/containers/QuestionsPage';
import QuestionPageProvider, {
  QuestionPageContext,
} from '$/containers/QuestionsPage/QuestionPageProvider';

export interface IQuestionsPageProps {
  mostPopularSpecializations: TQuestionAnswer[];
  degrees: TQuestionAnswer[];
}

const Questions = (props: IQuestionsPageProps) => (
  <Providers progressBarValue={0}>
    <QuestionPageProvider>
      <QuestionPageContext.Consumer>
        {({ background }) => (
          <Layout {...props} background={background} showFooter>
            <QuestionsPage {...props} />
          </Layout>
        )}
      </QuestionPageContext.Consumer>
    </QuestionPageProvider>
  </Providers>
);

export const getStaticProps: GetStaticProps = async () => {
  const idsOfMostPopularSpecializationsArray = specializationList.map(
    (element) => element.id
  );
  const getMostPopularSpecializationsResponse =
    await ApiClient.getMostPopularSpecializations({
      ids: idsOfMostPopularSpecializationsArray,
    });
  const mostPopularSpecializations =
    getMostPopularSpecializationsResponse?.length > 0
      ? getMostPopularSpecializationsResponse
      : specializationList;

  const idsOfDegrees = degreeList.map((element) => element.id);
  const getDegreesByIdsResponse = await ApiClient.getDegreesByIds({
    ids: idsOfDegrees,
  });
  const degrees =
    getDegreesByIdsResponse?.length > 0 ? getDegreesByIdsResponse : degreeList;

  return {
    props: {
      mostPopularSpecializations,
      degrees,
    },
  };
};

export default Questions;
